import { startOfDay } from 'date-fns';
import { flattenDeep } from 'lodash';
import { ScheduledItemType } from 'api/events';

type AgendaList = {
  [date: string]: Required<{ scheduledItemType: ScheduledItemType }>[];
};

export const groupSessionsByDay = (myAgenda?: AgendaList) => {
  const result = {};

  if (!myAgenda) return result;

  flattenDeep(Object.values(myAgenda)).forEach(session => {
    const dateKey = session.scheduledItemType === 'SESSION' ? 'start_date' : 'date';
    const startDay = startOfDay(new Date(session[dateKey])).toISOString();

    if (result[startDay]) {
      result[startDay].push(session);
    } else {
      result[startDay] = [session];
    }
  });

  return result;
};
